import { z } from 'zod';

export const createGlossaryTermSchema = z.object({
  term: z.string()
    .min(1, 'Term is required')
    .max(255, 'Term must be less than 255 characters')
    .trim(),
  description: z.string()
    .min(1, 'Description is required')
    .max(5000, 'Description must be less than 5000 characters')
    .trim(),
  technicalDescription: z.string()
    .max(5000, 'Technical description must be less than 5000 characters')
    .trim()
    .optional()
    .or(z.literal('')),
  tags: z.array(z.string().trim().min(1))
    .max(20, 'Maximum 20 tags allowed')
    .default([]),
  aliases: z.array(z.string().trim().min(1))
    .max(10, 'Maximum 10 aliases allowed')
    .default([]),
  relatedTermIds: z.array(z.string().uuid('Invalid term ID'))
    .max(20, 'Maximum 20 related terms allowed')
    .default([])
});

export const updateGlossaryTermSchema = z.object({
  term: z.string()
    .min(1, 'Term is required')
    .max(255, 'Term must be less than 255 characters')
    .trim()
    .optional(),
  description: z.string()
    .min(1, 'Description is required')
    .max(5000, 'Description must be less than 5000 characters')
    .trim()
    .optional(),
  technicalDescription: z.string()
    .max(5000, 'Technical description must be less than 5000 characters')
    .trim()
    .optional()
    .or(z.literal('')),
  tags: z.array(z.string().trim().min(1))
    .max(20, 'Maximum 20 tags allowed')
    .optional(),
  aliases: z.array(z.string().trim().min(1))
    .max(10, 'Maximum 10 aliases allowed')
    .optional(),
  relatedTermIds: z.array(z.string().uuid('Invalid term ID'))
    .max(20, 'Maximum 20 related terms allowed')
    .optional()
});

export const glossarySearchSchema = z.object({
  search: z.string().trim().optional(),
  tags: z.array(z.string().trim().min(1)).optional(),
  limit: z.coerce.number().min(1).max(100).default(20),
  offset: z.coerce.number().min(0).default(0)
});

// Types are exported from the types module to avoid conflicts